export default __webpack_public_path__ + "static/media/icon-coin-lrc.71cd8052.svg";